import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom'; // TODO: 詳細ページ実装後に復活
import './WorksComponents.css';

const WorksComponents = () => {
  const [worksData, setWorksData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || 'https://bohpj-website.onrender.com'}/api/works`)
      .then(res => {
        if (!res.ok) throw new Error('データの取得に失敗しました');
        return res.json();
      })
      .then(data => {
        const actualData = Array.isArray(data) ? data : (data.items || []);
        setWorksData(actualData);
      })
      .catch(error => {
        console.error("通信エラー:", error);
        setWorksData([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="works-grid">
      {loading
        ? [1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="work-card">
              <div className="work-card-image skeleton" />
              <div className="work-card-content">
                <div className="work-card-meta">
                  <div className="skeleton" style={{ width: 80, height: 24, borderRadius: 20 }} />
                  <div className="skeleton" style={{ width: 70, height: 16 }} />
                </div>
                <div className="skeleton" style={{ width: '90%', height: 18, marginTop: 12 }} />
                <div className="skeleton" style={{ width: '60%', height: 18, marginTop: 8 }} />
              </div>
            </div>
          ))
        : worksData.map((work) => (
            <div key={work.id} className="work-card"> {/* TODO: 詳細ページ実装後に <Link to={`/works/${work.id}`}> に戻す */}
              <div className="work-card-image">
                <img
                  src={
                    (work.images?.find(img => img.is_thumbnail) || work.images?.[0])?.url
                    || work.imageUrl || 'https://res.cloudinary.com/de301ufoq/image/upload/v1775915341/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-04-11_22.48.47_xo9nol.png'
                  }
                  alt={work.title}
                />
              </div>
              <div className="work-card-content">
                <div className="work-card-meta">
                  <div className="work-card-labels">
                    {(work.labels || []).map((label, index) => (
                      <span key={index} className="work-label">{label}</span>
                    ))}
                  </div>
                  <div className="work-card-date">{work.date}</div>
                </div>
                <h3 className="work-card-title">{work.title}</h3>
              </div>
            </div>
          ))
      }
    </div>
  );
};

export default WorksComponents;